import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_API;

/**
 * Login lewat OpenID Provider One LNK (be-sso), menggantikan login-ulang
 * berbekal password yang dibawa cookie `ssocookies`.
 *
 * Alur di browser:
 *   1. FE mengalihkan halaman ke `auth/oidc/login` di be-ellenkasquad (navigasi penuh,
 *      bukan XHR -- OP perlu melihat cookie sesi milik domain SSO).
 *   2. OP membaca sesi login yang sudah ada, lalu memulangkan browser ke
 *      `auth/oidc/callback` milik be-ellenkasquad.
 *   3. be-ellenkasquad menukar code lewat penukar terpusat, lalu memulangkan browser
 *      ke FE dengan `?oidc_ticket=` -- TIKET saja, bukan token, supaya sesi
 *      tidak tercatat di riwayat browser, header Referer, maupun log akses
 *      ALB/nginx.
 *   4. FE menebus tiket itu lewat XHR di sini.
 *
 * Bila langkah 2 atau 3 gagal (mis. akun belum terdaftar), be-ellenkasquad tetap
 * memulangkan browser ke FE, tapi dengan `?oidc_error=<pesan>` -- bukan tiket.
 */
const PARAM_TIKET = 'oidc_ticket';
/** Nama parameter galat yang dipakai callback be-ellenkasquad. */
const PARAM_GALAT = 'oidc_error';

/**
 * Saklarnya `'true'` PERSIS. CRA membakar `process.env.REACT_APP_*` sebagai
 * STRING saat build, jadi `'false'` dan `'0'` sama-sama truthy kalau diperiksa
 * apa adanya -- dan saklar yang tidak bisa dimatikan lebih buruk daripada tidak
 * ada saklar.
 */
const aktif = () => process.env.REACT_APP_OIDC_ENABLED === 'true';

const urlLogin = (redirectUrl) =>
	`${API_URL}auth/oidc/login?redirect_url=${encodeURIComponent(redirectUrl)}`;

/**
 * Akhiri sesi di OP. Navigasi penuh ke be-ellenkasquad, yang meneruskan ke
 * `end_session` — frontend tidak tahu issuer maupun client_id, dan memang tidak
 * perlu tahu. Pola yang sama dengan `urlLogin`.
 */
const urlLogout = () => `${API_URL}auth/oidc/logout`;

const status = async () => {
	return axios.get(`${API_URL}auth/oidc/status`).then((res) => res.data);
};

const redeem = async (ticket) => {
	return axios
		.post(`${API_URL}auth/oidc/redeem`, { ticket }, { headers: await authHeader() })
		.then((res) => res.data);
};

export default { aktif, urlLogin, urlLogout, status, redeem, PARAM_TIKET, PARAM_GALAT };
